module.exports = "/images/fo.svg?90a2b980f29be25e5055b95b196d0902";